
import { defineComponent } from 'vue';
import {
  ContentBlock,
} from 'CoreHome';
import URLChecker from '../URLChecker/URLChecker';
import ManageSearchEngines from '../ManageSearchEngines/ManageSearchEngines';
import ManageSocials from '../ManageSocials/ManageSocials';

const { $ } = window;

export default defineComponent({
  props: {
    title: String,
    ownSocialDefinitions: Boolean,
  },
  mounted() {
    const tabs = this.$refs.tabs as HTMLElement;
    setTimeout(() => {
      $('.tabs', tabs).tabs();
    });
  },
  components: {
    ContentBlock,
    URLChecker,
    ManageSearchEngines,
    ManageSocials,
  },
});
